<template>
<v-container fluid>
  <v-card>
    <v-card-title>
      <span class="headline mb-0">ロングドレー判定テーブル</span>
    </v-card-title>
    <v-card-actions>
      <v-btn @click="save()" :disabled="!valid">{{
          $t('app.buttons.save')
        }}</v-btn>
      <v-btn @click="$router.go(-1)">{{ $t('app.buttons.back') }}</v-btn>
    </v-card-actions>
    <v-form v-model="valid">
      <v-container fluid>
        <v-layout wrap>
          <v-flex md3 sm6 xs6>
            <remote-autocomplete :label="$t('app.labels.dischargePort')" url="ports/kv" v-model="root.dischargePortCode"></remote-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex md3 sm6 xs6>
            <remote-autocomplete label="最終納入場所" url="warehouses/reservable-kv" v-model="root.warehouseId"></remote-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-card>
</v-container>
</template>

<script>
/* eslint-disable no-console */
export default {
  data() {
    return {
      valid: null,
      id: null,
      root: {},
    }
  },
  methods: {
    returnToList() {
      this.$router.push({
        name: 'M0300',
      })
    },
    initData() {
      this.root.code = this.$route.query.code
      this.root.name = this.$route.query.name
    },
    save() {
      this.$http
        .post(`/long-distance-routes`, this.root)
        .then(() => {
          this.returnToList()
          this.$message('', 'Success')
        })
        .catch(() => {
          this.$message('', 'Error')
        })
    },
  },
  mounted() {
    this.initData()
  },
}
</script>
